import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "rank-history-new",
  components: {
    AppHeader
  },
  async created() {
    this.getUser();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      rankHistory: {
        user_id: this.$route.params.user_id,
        change_date: "",
        one_evaluation: "",
        two_evaluation: "",
        three_evaluation: "",
        rank: "",
        content: "",
        savingFlag: false
      },
      user: ""
    };
  },
  computed: {
    changeDateFormat() {
      return dayjs(
        `${this.changeYear}-${this.changeMonth}-${this.changeDay}`
      ).format("YYYY-MM-DD");
    },
    changeDateBeforeToday() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (this.changeDateFormat <= dayjs().format("YYYY-MM-DD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async createRankHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.rankHistory.change_date = this.changeDateFormat;
      let data = this.rankHistory;
      let res = await this.$store
        .dispatch("CREATE_RANK_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goRankHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goRankHistory() {
      this.$router.push({
        path: `/rank_history/${this.$route.params.user_id}`
      });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
